'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus from "./app.data.-General-Practice-Status.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$() {
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMake$lzy3 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMakebitmap$3 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_make$lzy3 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_makebitmap$3 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_validator = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Type$lzy3 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Typebitmap$3 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodec$lzy3 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodecbitmap$3 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertible$lzy3 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertiblebitmap$3 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Typebitmap$1 = false;
  $n_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ = this;
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_NewtypeNonEmptyString$().Lframework_utils_NewtypeNonEmptyString$__f_validators;
  var suffix = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lyantl_ValidatorRule$().maxLength__I__Lyantl_ValidatorRule(200)]);
  var this$4 = this$2.genericWrapArray__O__sci_ArraySeq(suffix);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var delta = arr.u.length;
  this$4.length__I();
  var length = arr.u.length;
  var i = 0;
  while ((i < length)) {
    var x1$1 = i;
    var elem = arr.u[x1$1];
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
    i = ((1 + i) | 0);
  }
  var it = this$4.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem$1 = it.next__O();
    var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
    jsElems.push(unboxedElem$1);
  }
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_validator = $x_1.fromRules__ALyantl_ValidatorRule__Lyantl_Validator(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)(jsElems));
}
export { $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ as $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ };
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.constructor = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$;
/** @constructor */
function $h_Lapp_data_types\uff3fpharmacy$package$PharmacyName$() {
}
export { $h_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ as $h_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ };
$h_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype;
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMakebitmap$3)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMake$lzy3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMakebitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_defaultMake$lzy3;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_makebitmap$3)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_make$lzy3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_makebitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_make$lzy3;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_validator;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Typebitmap$3)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Type$lzy3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Typebitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_Show_Type$lzy3;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.tapirCodec__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodecbitmap$3)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodec$lzy3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodecbitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_tapirCodec$lzy3;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.urlConvertible__Lframework_utils_UrlConvertible = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertiblebitmap$3)) {
    var codec = this.tapirCodec__Lsttp_tapir_Codec();
    var errorFromThrowable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsFromThrowable__Lurldsl_errors_ErrorFromThrowable();
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertible$lzy3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_utils_UrlConvertible$fromCodec(codec, errorFromThrowable);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertiblebitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_urlConvertible$lzy3;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$.prototype.given_LocalizedTextOf_Type__Lframework_localization_LocalizationSupport$LocalizedTextOf = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Typebitmap$1)) {
    var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedTextOf__Lframework_localization_LocalizationSupport$LocalizedTextOf$();
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$7(this$1);
    var x = $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus.$m_Lapp_localization_L18n$().Lapp_localization_L18n$__f_Name;
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Type$lzy1 = this$2.apply__Lframework_localization_LocalizationSupport$LocalizedText__Lframework_localization_LocalizationSupport$LocalizedTextOf(x);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyName$__f_given_LocalizedTextOf_Type$lzy1;
});
var $d_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$, "app.data.types_pharmacy$package$PharmacyName$", ({
  Lapp_data_types\uff3fpharmacy$package$PharmacyName$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$ValidatedOf: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1
}));
export { $d_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ as $d_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ };
var $n_Lapp_data_types\uff3fpharmacy$package$PharmacyName$;
function $m_Lapp_data_types\uff3fpharmacy$package$PharmacyName$() {
  if ((!$n_Lapp_data_types\uff3fpharmacy$package$PharmacyName$)) {
    $n_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ = new $c_Lapp_data_types\uff3fpharmacy$package$PharmacyName$();
  }
  return $n_Lapp_data_types\uff3fpharmacy$package$PharmacyName$;
}
export { $m_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ as $m_Lapp_data_types\uff3fpharmacy$package$PharmacyName$ };
//# sourceMappingURL=app.data.types_pharmacy$package$-Pharmacy-Name$.js.map
